import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';

// Copied from workspaces/frontend/src/state/apple-pay/hooks/use-can-use-apple-pay.web.ts

export function useApplePayAvailability() {
  const applePayPluginAvailable = useFlag(LaunchDarklyFlag.ENABLE_APPLE_PAY);
  let canMakePayments = false;
  if (window.ApplePaySession) {
    try {
      canMakePayments = ApplePaySession.canMakePayments();
    } catch {
      canMakePayments = false;
    }
  }
  return canMakePayments && applePayPluginAvailable;
}
